module.exports = __webpack_public_path__ + "img/BOÉ_S.d6cbad78.png";